/**
 * @Author Morsal
 */
import { GameEvent } from "../enums/GameEvent";
import { Page } from "../enums/Page";
import { GameEventService, SwitchPageEvent } from "../services/GameEventService";

/** Handles modal-based rendering of Cable Puzzle as overlay */
export class CablePuzzleModal {
    private readonly gameEventService: GameEventService = new GameEventService();

    public constructor() {
        // Luister naar page switch events
        this.gameEventService.addGameEventListener<SwitchPageEvent>(GameEvent.SwitchPage, event => {
            if (event.page === Page.CablePuzzle) {
                this.openCablePuzzleModal();
            }
        });
    }

    private openCablePuzzleModal(): void {
        if (!document.getElementById("cable-puzzle-overlay")) {
            const overlay: HTMLElement = document.createElement("cable-puzzle-page");
            overlay.id = "cable-puzzle-overlay";
            document.body.appendChild(overlay);
        }
    }

    public static closeCablePuzzleModal(): void {
        const modal: HTMLElement | null = document.getElementById("cable-puzzle-overlay");
        if (modal) {
            modal.remove();
        }
    }
}
